














import BackLink from "@/components/app/BackLink.vue";
import { StatementVue } from "fs-pb-vue2/vueModels/history/StatementVue";
import StatementList from "@/components/history/StatementList.vue";
import { Component } from "vue-property-decorator";

@Component({
  components: { StatementList, BackLink }
})
export default class Statement extends StatementVue {
  get statementTitle(): string {
    if (this.contract) {
      if (+this.$route.params.cardId) {
        return `Карта: ${this.card.Data.Alias}`;       
      }
      return `Счет: ${this.contract.Data.Alias}`;
    }
    return '';
  }

  get isModal(): boolean {
    return this.$route.query.operInfo && this.$route.query.operInfo.length > 0;
  }
}
